import I18n from 'i18n-js';
import React from 'react';
import CmsListingsCollection from '@reverbdotcom/commons/src/cms/components/cms_listings_collection';
import { dealsAndStealsPromoURLPath } from './promo_deals_and_steals_url_path';
import { useUser, useExpEnabled } from '@reverbdotcom/commons/src/user_hooks';
import experiments from '@reverbdotcom/commons/src/experiments';
import { US_CON_CODE } from './shared/constants';
import { DEALS_AND_STEALS_CURATED_SET_ID } from '@reverbdotcom/commons/src/constants';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';
import { reverb_search_ListingsSearchRequest_PriceValue } from '@reverbdotcom/commons/src/rql';

const GOOD_AND_ABOVE = ['new', 'excellent', 'b-stock', 'mint', 'excellent', 'very-good', 'good'];
const ALL_EXCEPT_PARTS_AND_ACCESSORIES = [
  'fa10f97c-dd98-4a8f-933b-8cb55eb653dd', // effects and pedals
  'dfd39027-d134-4353-b9e4-57dc6be791b9', // electric guitars
  'b021203f-1ed8-476c-a8fc-32d4e3b0ef9e', // pro audio
  '09055aa7-ed49-459d-9452-aa959f288dc2', // amps
  'b3cb9f8e-4cb6-4325-8215-1efcd9999daf', // drums and percussion
  'd002db05-ab63-4c79-999c-d49bbe8d7739', // keyboards and synths
  '3ca3eb03-7eac-477d-b253-15ce603d2550', // acoustic guitars
  '032c74d0-b0e2-4442-877f-e1a22438a7fa', // band and orchestra
  'fb60628c-be4b-4be2-9c0f-bc5d31e3996c', // folk instruments
  '53a9c7d7-d73d-4e7f-905c-553503e50a90', // bass guitars
  '40e8bfd0-3021-43f7-b104-9d7b19af5c2b', // home audio
  '58d889f7-0aa1-4689-a9d3-da16dd225e8d', // dj and lighting gear
];

export default function HomepageDealsAndStealsListingsCollection() {
  const user = useUser();
  const dealsAndStealsPath = dealsAndStealsPromoURLPath(user);

  const eligible = user.shippingRegionCode === US_CON_CODE;
  const usePriceRecs = useExpEnabled(experiments.DEALS_AND_STEALS_ROWS_V2) && eligible;

  const mParticleView = {
    componentName: 'ExperimentalDealsAndStealsRow',
    eventName: MParticleEventName.ComponentView,
    experiments: formatExperimentsForEventAttributes(user, [
      experiments.DEALS_AND_STEALS_ROWS_V2,
    ]),
  };

  return (
    <CmsListingsCollection
      data-deals-and-steals-listings
      curatedSetId={usePriceRecs ? undefined : DEALS_AND_STEALS_CURATED_SET_ID}
      componentName="HomepageDealsAndSteals"
      ctaTargetHref={dealsAndStealsPath}
      dealsOrWellPriced={usePriceRecs ? true : undefined}
      conditionSlugs={usePriceRecs ? GOOD_AND_ABOVE : undefined}
      categoryUuids={usePriceRecs ? ALL_EXCEPT_PARTS_AND_ACCESSORIES : undefined}
      priceValueV2={reverb_search_ListingsSearchRequest_PriceValue.GOOD}
      shipsToMe={usePriceRecs}
      title={I18n.t('discovery.categoryNavBar.explore.deals')}
      maxCount={12}
      largeTiles
      ssr={false}
      mParticleView={eligible ? mParticleView : undefined}
    />
  );
}
